import React, { type ChangeEvent, useEffect, useState } from "react";
import { tt } from "../../../utils/i18n/i18n";
import { POSAPricesSelect } from "./POSAPricesSelect";
import KCInput from "../../common/KCInput/KCInput";
import TestsID from "../../../utils/TestsID";
import TSUtils from "../../../utils/helpers/TSUtils";
import { type POSAOrderItem } from "../../../redux/saas/reducer";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import { SaasFlyersOrderQuantityRowI } from "../../../model/saasFlyersOrderQuantityRowI";
import {
  DEFAULT_CURRENCY_SUB_UNITS,
  Currencies
} from "@tootsweet/model/enums/Currencies";

// TODO EGH: delete this
export const SaasFlyersOrderQuantityRow = (
  props: SaasFlyersOrderQuantityRowI
) => {
  const [total, setTotal] = useState<POSAOrderItem>();
  const [qty, setQty] = useState<number | undefined>(props.initialValue?.qty);
  const [priceHT, setPriceHT] = useState<number | undefined>(
    props.initialValue?.priceHT
  );
  const { accountToDisplay } = useAccountToDisplaySelector();

  function handleChange(e: ChangeEvent<HTMLSelectElement | HTMLInputElement>) {
    if (isNaN(Number(e?.target?.value))) return;
    setQty(Number(e.target.value));
    if (props.posaType?.hasPriceList) {
      // @ts-ignore
      const value: number = props.posaPrices.prices[e.target.value] || 0;
      setPriceHT(value);
    } else {
      setPriceHT(
        (Number(e.target.value) || 0) * (props.posaType?.unitPrice ?? 0)
      );
    }
  }

  useEffect(() => {
    if (
      priceHT === undefined ||
      priceHT === null ||
      qty === undefined ||
      qty === null ||
      !props.posaType ||
      accountToDisplay?.isAll
    ) {
      alert(tt("api_error"));
      return;
    }
    setTotal({
      priceHT,
      vat: 0,
      priceTTC: 0,
      qty,
      name: props.posaType.name,
      posaTypeId: props.posaType._id,
      businessUserId: accountToDisplay?.trackingID
    });
  }, [priceHT, qty]);

  useEffect(() => {
    if (total?.posaTypeId) {
      props.handleTotal(props.posaType?._id, total);
    }
  }, [total]);

  return (
    <tr
      key={props.posaType._id}
      className="saas-flyers-order__quantity-selection-tr"
    >
      <td>{props.posaType.name}</td>
      <td>{props.posaType.desc}</td>
      <td className="kc-table-td-center">
        <div
          id={TestsID.SAAS_FLYERS_ORDER_PAGE_QUANTITY_INPUT_WRAPPER}
          className="saas-flyers-order__quantity-selection-input "
        >
          {props.posaType.hasPriceList ? (
            <>
              {props.posaPrices != null && (
                <POSAPricesSelect
                  id={`${TestsID.SAAS_FLYERS_ORDER_PAGE_QUANTITY_INPUT}-${props.posaType?.name}`}
                  prices={props.posaPrices.prices}
                  handlePrice={handleChange}
                  priceKey={qty?.toString()}
                />
              )}
            </>
          ) : (
            <>
              <KCInput
                id={`${TestsID.SAAS_FLYERS_ORDER_PAGE_QUANTITY_INPUT}-${props.posaType?._id}`}
                label=""
                placeholder=""
                type="number"
                value={qty}
                name={props.posaType.name}
                onChange={handleChange}
              />
            </>
          )}
        </div>
      </td>
      <td className="kc-table-td-center">
        {!props.posaType?.hasPriceList
          ? TSUtils.formatAmount(
              (props.posaType.unitPrice ?? 0) *
                (props.posaType.noMarkup ? 1 : 1.5),
              DEFAULT_CURRENCY_SUB_UNITS,
              false,
              Currencies.CURRENCY_EUR
            )
          : tt("not_applicable")}
      </td>
      <td className="kc-table-td-center">
        {total?.priceTTC
          ? TSUtils.formatAmount(
              total?.priceTTC,
              DEFAULT_CURRENCY_SUB_UNITS,
              false,
              Currencies.CURRENCY_EUR
            )
          : `0${tt("money_sigle")}`}
      </td>
    </tr>
  );
};
